export default __webpack_public_path__ + "static/media/co_pep_front.2a5f8503.jpeg";